import { connect } from 'react-redux'

import Map from '../components/Map'

const mapStateToProps = (state) => ({
  activeProperty: state.search.activeProperty,
  googleApiKey: state.search.googleApiKey,
  map: state.search.map,
  results: state.search.results,
})

export default connect(mapStateToProps)(Map)



// WEBPACK FOOTER //
// ./src/containers/Map.js